























































































































































import { ChangePasswordVue } from "fs-pb-vue2/vueModels/settings/ChangePasswordVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: { VerifyBox, BackLink }
})
export default class PasswordEditModal extends ChangePasswordVue {
  isNewPasswordValid: boolean = false;
  newPassword: string = "";
  inputTouched: boolean = false;

  async mounted() {
    await this.init();
  }

  newPasswordRulesStatus: {
    minLength: boolean;
    hasUpperCase: boolean;
    hasLowerCase: boolean;
    hasNumber: boolean;
    hasSymbol: boolean;
    passwordsMatch: boolean;
  } = {
    minLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    hasSymbol: false,
    passwordsMatch: false,
  };

  get testNewPassword(): () => void {
    return () => {
      this.inputTouched = true;

      this.newPasswordRulesStatus.minLength = this.OperationModel.NewPassword.length >= 8;
      this.newPasswordRulesStatus.hasUpperCase = /[A-Z]/.test(this.OperationModel.NewPassword);
      this.newPasswordRulesStatus.hasLowerCase = /[a-z]/.test(this.OperationModel.NewPassword);
      this.newPasswordRulesStatus.hasNumber = /\d/.test(this.OperationModel.NewPassword);
      this.newPasswordRulesStatus.hasSymbol = /(?=.*[.\^$*+?{\\[\\\]|()\/\-,:;!%<>@_#'\"№&=~])/.test(this.OperationModel.NewPassword);
      this.newPasswordRulesStatus.passwordsMatch = this.OperationModel.NewPassword === this.OperationModel.ConfirmPassword;
    };
  }

  checkPasswordsMatch() {
    this.newPasswordRulesStatus.passwordsMatch = this.OperationModel.NewPassword === this.OperationModel.ConfirmPassword;
  }
}
